<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="c05">
<div class="chbrd">
<h1 class="chapter_date"><a id="page20"></a><strong>c. 540 BCE</strong></h1>
<h1 class="chapter_title">Ahimsa</h1>
<p class="bauthorb"><strong>Nataputta Vardhamana (Mahavira)</strong> (c. 599–c. 527 BCE)</p>
</div>
<p class="nonindent">The sixth century BCE was an exciting time to live in India. The Hindu Upanishads were being written around this period, and two major religions emerged as reactions to the orthodox schools of Hinduism. One was Buddhism; the other was Jainism, which was founded by Nataputta Vardhamana, known as Mahavira (“Great Hero” in Sanskrit), sometime in the middle of the sixth century BCE, though some scholars think it was a few decades later.</p>
<p class="indent">According to Jain sources, Mahavira was born in 599 BCE in northeastern India, not far from present-day Nepal. Following a privileged upbringing as part of a royal family, Mahavira decided at the age of thirty to renounce the world and seek enlightenment. Few have ever done so with greater determination. For over twelve years he wandered naked all over India, practicing extreme bodily austerities and carefully avoiding all harm to other creatures. Finally, in his early forties, he achieved complete enlightenment and release (<em>moksha</em>). For the next thirty years he taught others the path to liberation that he had discovered. He ended his own life, at age seventy-two, by voluntary self-starvation.</p>
<p class="indent">Like Hindus and Buddhists, Jains believe in karma and reincarnation. The ultimate goal of life, they hold, is to liberate the soul from karma and rebirth. The way they seek to do this is by practicing asceticism (self-denial, nonattachment) and trying to avoid all injury to other life forms. Jain monks pursue this path in a particularly rigorous way, taking five vows that include celibacy, complete nonpossessiveness, noninjury or nonviolence (<em>ahimsa</em>), truthfulness, and refusing to take anything that isn’t given to them. Lay Jains are allowed to marry and pursue a more moderate (but still extremely disciplined) lifestyle of renunciation.</p>
<p class="indent">Jains believe that all living things have souls, and they take great care to avoid any unnecessary killing or harm. Mahavira himself reportedly used a broom to gently sweep the ground in front of his feet, lest he should tread on any tiny creatures. This idea of ahimsa greatly influenced many Indian schools of philosophy.</p>
<p class="captionl" id="img21"><em>A miniature painting depicting Mahavira, founder of the Jain religion, from a c. 1503 manuscript of the</em> Kalpa Sūtra, <em>a sacred Jain text.</em></p>
<div class="dis_imgb"><a id="page21"></a><img alt="" src="OEBPS/images/21-1.jpg"/></div>
<div class="xref">
<p class="seal"><span class="sls"><strong>SEE ALSO</strong></span> <a class="hlink" href="#/OEBPS/9781454935575_c01">The Vedas (c. 1500 BCE)</a>, <a class="hlink" href="#/OEBPS/9781454935575_c04">Reincarnation (c. 540 BCE)</a></p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454935575_c05.vue?3b81108b